<mat-form-field>
  <input matInput [formControl]="formControl" [placeholder]="placeholder" />
</mat-form-field>
